import { SVGProps, Ref, forwardRef } from 'react';

export const LineArrowRightOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M17.364 17.637 23 12l-5.636-5.636-1.273 1.273 3.463 3.463H8.727v1.8h10.827l-3.463 3.464z"
                    fill="currentColor"
                />
                <path
                    d="M1 12c0 9.625 1.375 11 11 11v-1.8c-2.392 0-4.14-.088-5.446-.334-1.289-.243-1.97-.608-2.39-1.03-.422-.42-.787-1.101-1.03-2.39C2.888 16.14 2.8 14.392 2.8 12s.088-4.14.334-5.446c.243-1.289.608-1.97 1.03-2.39.42-.422 1.101-.787 2.39-1.03C7.86 2.888 9.608 2.8 12 2.8V1C2.375 1 1 2.375 1 12"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
LineArrowRightOutlinedSize24Glyph.displayName = 'LineArrowRightOutlinedSize24Glyph';
